import { render, staticRenderFns } from "./TaskFieldLabels.vue?vue&type=template&id=1ba18412&"
import script from "./TaskFieldLabels.vue?vue&type=script&lang=js&"
export * from "./TaskFieldLabels.vue?vue&type=script&lang=js&"
import style0 from "./TaskFieldLabels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba18412')) {
      api.createRecord('1ba18412', component.options)
    } else {
      api.reload('1ba18412', component.options)
    }
    module.hot.accept("./TaskFieldLabels.vue?vue&type=template&id=1ba18412&", function () {
      api.rerender('1ba18412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/TaskFieldLabels.vue"
export default component.exports